import { COMMON_LANGUAGES } from "@sdbn/common";
import { DefaultSettings } from "./default";

// ACHTUNG: Werden hier Parameter aufgenommen, sind diese auch im Dockerfile für das "envsubst" zu ergänzen.

const tmcBaseUrl = "${TMC_BASE_URL}";
const tmcClientUrl = "${TMC_CLIENT_URL}";

const languagesString = "${TMC_LANGUAGES}";

const enableLoggingString = "${TMC_LOGGING_ENABLED}";

const simulatorEnabledString = "${TMC_SIMULATOR_ENABLED}";

const defaultSettings = DefaultSettings.get(tmcBaseUrl, tmcClientUrl);

export const environment = {
  ...defaultSettings,
  production: true,
  autoreload: true,

  languageOptions: languagesString?.trim()
    ? defaultSettings.languageOptions
    : languagesString
        .split("|")
        .map((language) => COMMON_LANGUAGES.find((l) => l.key === language)!),

  enableLogging:
    enableLoggingString.toLowerCase().replace("true", "").length === 0,
  simulatorAvailable: simulatorEnabledString,
};
